import { render, staticRenderFns } from "./VehicleNew.vue?vue&type=template&id=55db21ca"
import script from "./VehicleNew.vue?vue&type=script&lang=js"
export * from "./VehicleNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports